import React from 'react';
import { Dropdown } from 'semantic-ui-react';

const SelectTouroperator = (props) => {
    if (!props.authUser.isAdmin) return null;
    if (!props.tour_operators) return null;

    let curTopName = props.tour_operators[props.authUser.tour_operator].name;

    let sortedKeys = Object.keys(props.tour_operators).sort((a, b) => {
        if (props.tour_operators[a].name < props.tour_operators[b].name) return -1;
        return 1;
    });

    let items = sortedKeys.map((key) => (
        <Dropdown.Item key={key} onClick={() => props.onChange(key)} active={curTopName === props.tour_operators[key].name}>
            {props.tour_operators[key].name}
        </Dropdown.Item>
    ))

    return (
        <Dropdown item text={curTopName} onChange={props.onChange}>
            <Dropdown.Menu style={{ "height": "500px", "overflow": "auto" }}>
                {items}
            </Dropdown.Menu>
        </Dropdown>
    )
}

export default SelectTouroperator;


// WEBPACK FOOTER //
// ./src/common/SelectTouroperator.js